import { CosmosCrest } from './CosmosCrest'
import { cn } from '@/lib/utils'

interface Props {
  className?: string
  size?: 'sm' | 'md' | 'lg'
  animated?: boolean
}

const sizes = {
  sm: { crest: 44, text: 'text-xl', sub: 'text-[9px]' },
  md: { crest: 52, text: 'text-2xl', sub: 'text-[10px]' },
  lg: { crest: 72, text: 'text-3xl', sub: 'text-[11px]' },
}

export function Wordmark({ className, size = 'md', animated }: Props) {
  const s = sizes[size]
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <CosmosCrest size={s.crest} animated={animated} />
      <div className="leading-none whitespace-nowrap">
        <div className={cn('font-display uppercase tracking-[0.03em] leading-none', s.text)}>
          Cosmos F.C.
        </div>
        <div
          className={cn(
            'uppercase tracking-[0.22em] text-muted-foreground font-body font-medium mt-1.5',
            s.sub
          )}
        >
          Vista · California
        </div>
      </div>
    </div>
  )
}
